import { GetterTree } from "vuex";
import { RootState } from "../types";
import { PaymentState } from "./types";

export const getters: GetterTree<PaymentState, RootState> = {};
